// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"63cad092","453":"fe15bc75","667":"d129102f"}[chunkId] + ".chunk.js";
};